import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { PrioridadCliente } from "../models/prioridadcliente";
import { VersionCliente } from "../models/versioncliente";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatInput } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { NgFor } from "@angular/common";
import { MatOption } from "@angular/material/autocomplete";
import { MatSelectionList, MatListOption } from "@angular/material/list";

@Component({
    selector: 'app-desarrollo-altas',
    templateUrl: './desarrollo-altas.html',
    styleUrls: ['./desarrollo-altas.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatSelect, NgFor, MatOption, MatSelectionList, MatListOption, MatButton]
})
  export class DesarrolloAltas implements OnInit{


  evidencia = [];

  index: number;

  selectedOptions = [];
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  totalsize = 0;
  formRegistro: FormGroup;
  open: string = 'ABIERTO';
  prioridadcliente:PrioridadCliente[];
  SelectPrioridad:Number;
  versioncliente:VersionCliente[];
  SelectVersion:Number;


    constructor( public dialogRef:MatDialogRef<DesarrolloAltas>,
      private formBuilder: FormBuilder, ){ }

    ngOnInit() {
    this.prioridadcliente =[{idp:1,nombrep:"Alta"},{idp:2,nombrep:"Media"},{idp:3,nombrep:"Baja"}]
    this.versioncliente=[{idv:1,nombrev:"version 1"},{idv:2,nombrev:"version 2"},{idv:3,nombrev:"version 3"},{idv:4,nombrev:"version 4"},{idv:5,nombrev:"version 5"},{idv:6,nombrev:"version 6"},{idv:7,nombrev:"version 7"},{idv:8,nombrev:"version 8"},{idv:9,nombrev:"version 9"},{idv:10,nombrev:"version 10"}]
        
      }
      subirEv() {
        const input = (<HTMLInputElement>document.getElementById('nameFile'));
        if (input.files.length > 0) {
          for (let i = 0; i <= input.files.length - 1; i++) {
            this.totalsize = this.totalsize + input.files.item(i).size;
            this.evidencia.push(input.files[i]);
          }
        }
        (<HTMLInputElement>document.getElementById('nameFile')).value = "";
      }
    
          onNgModelChange($event) {
        this.selectedOptions = $event;
        if (this.selectedOptions.length != 0) {
          this.btnElimina = false;
          this.btnAgrega = true;
        } else {
          this.btnElimina = true;
          this.btnAgrega = false;
        }
      }
    
      elimina() {
        for (let i = 0; i < this.selectedOptions.length; ++i) {
          this.index = this.evidencia.findIndex(item => item.name == this.selectedOptions[i].name);
          this.evidencia.splice(this.index, 1);
        }
        (<HTMLInputElement>document.getElementById('nameFile')).value = "";
      }
      onNoClick(): void {
        this.dialogRef.close();
      }
    
      onCloseClick() {
        this.dialogRef.close();
      }
    
      ngOnDestroy() {
        this.dialogRef.close();
      }
 /*Registros del form */
      formreg() {
        this.formRegistro = this.formBuilder.group({
          titulo: ['', [Validators.required]],
          prioridad: ['', [Validators.required]],
          version: ['', [Validators.required]],
          estatus: this.open,
          descripcion: ['', [Validators.required]]
        });
      }


}
